import React from 'react';
import Header from './Header';

const headerRenderer = ({ label, columnData }) => {
  return <Header label={label} columnData={columnData} />;
};

export default headerRenderer;
